import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, unref as _unref, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, isRef as _isRef, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d17ffd6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mt-10 mb-10" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("生成NO")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("清除NO")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("创建询证函")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("上传询证函")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("下载")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("更新信息")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("锁定/解锁")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("创建替代测试")
const _hoisted_11 = ["onDblclick"]
const _hoisted_12 = /*#__PURE__*/_createTextVNode("下载")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("下载")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("修改询证函")

import { ref, Ref, reactive, onBeforeMount, computed } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import tbMix from '@/global_mixin/tableMixin'
import { confirmationOption } from '@/views/typeMapping/Financial';
import {useRouter} from 'vue-router'
import { formatNumber, getNumber, exportHandle } from '@/utils/index'
import PaymentModuleUtils from "@/views/typeMapping/PaymentModuleUtils"
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const {
  // 询证函列表
  'POST/confirmation/page': fetchList,
  // 删除询证函
  'POST/confirmation/delete': deleteApi,
  // 下载询证函
  'POST/confirmation/download': downloadApi,
  // 开票公司列表
  'GET/order/invoice_companies': invoice_companiesApi,
  // 更新信息
  'POST/confirmation/info/update': updateApi,
  // 上传询证函
  'POST/confirmation/upload': uploadApi,
  // 创建询证函
  'POST/confirmation/confirmation_file': createConfirmation_fileApi,
  // 导出询证函
  'POST/confirmation/export': exportApi,
  // 生成no
  'PUT/confirmation/no/create': createNoApi,
  // 取消no
  'PUT/confirmation/no/clear': clearNoApi,
  // 修改询证函
  'POST/confirmation/update': updateConfirmationApi,
  // 锁定or解锁询证函记录
  'POST/confirmation/locked': lockedApi,
  // 创建替代测试
  'POST/confirmation/alternative_test': alternative_testApi,
} = Api

let {currencyOption} = PaymentModuleUtils
let selectionRows: any = ref([])
const { 
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height
} = new tbMix(fetchList)

let companyInvice = ref([])
invoice_companiesApi().then((rep: any) => {
  companyInvice.value = rep.map((com: string) => {
    return { label: com, id: com }
  }).concat([{label: '空白', id: '空白'}])
})

const router = useRouter()
const searchConfig = ref([
  {
    type: "TIME",
    label: "开始日期",
    value: '',
    upKey: 'startDate',
    props: {},
    rule: [{required: true, message: '请选择日期', trigger: 'change'}]
  },
  {
    type: "TIME",
    label: "结束日期",
    value: '',
    upKey: 'endDate',
    props: {},
    rule: [{required: true, message: '请选择日期', trigger: 'change'}]
  },
  {
    label: '函证序号',
    value: '',
    upKey: 'brokerNo',
  },
  {
    label: '客户ID',
    value: '',
    upKey: 'customerId',
  },
  {
    label: '客户名称',
    value: '',
    upKey: 'customerName',
  },
  /* {
    label: '财务认定客户',
    value: '',
    upKey: 'financialName',
  }, */
  {
    type: 'SELECT',
    label: '财务认定客户',
    value: '',
    upKey: 'financialName',
    options: [
      {label: '空', id: '空'},
      {label: '非空', id: '非空'},
    ],
    props: { placeholder: '请选择财务认定客户', clearable: true},
    seleProps: { label: 'label', valueName: 'id', },
  },
  {
    label: '销售',
    value: '',
    upKey: 'sale',
  },
  /* {
    label: '询证函主体',
    value: '',
    upKey: 'confirmationCompany',
  }, */
  {
    type: 'SELECT',
    label: '询证函主体',
    value: '',
    upKey: 'confirmationCompany',
    options: companyInvice,
    props: {clearable: true, placeholder: '请选择询证函主体'},
    seleProps: {
      label: 'label',
      valueName: 'id',
    },
  },
  {
    type: 'SELECT',
    label: '公司',
    value: '',
    upKey: 'invoiceCompany',
    options: companyInvice,
    props: {clearable: true, placeholder: '请选择公司'},
    seleProps: { label: 'label', valueName: 'id', },
  },
  {
    type: 'SELECT',
    label: '币种',
    value: '',
    upKey: 'currency',
    options: currencyOption(),
    props: { placeholder: '请选择币种', clearable: true},
    seleProps: {
      label: 'label',
      valueName: 'id',
    },
  },
  {
    type: 'SELECT',
    label: '是否合格',
    value: '',
    upKey: 'status',
    options: [
      {label: '合格', id: '1'},
      {label: '不合格', id: '0'},
      {label: '空白', id: 'null'},
    ],
    props: { placeholder: '请选择是否合格', clearable: true},
    seleProps: {
      label: 'label',
      valueName: 'id',
    },
  },
  {
    type: 'SELECT',
    label: '境内外',
    value: '',
    upKey: 'domestic',
    options: [
      {label: '境内', id: '1'},
      {label: '境外', id: '0'},
      {label: '未知', id: 'null'},
    ],
    props: { placeholder: '请选择国内外', clearable: true},
    seleProps: {
      label: 'label',
      valueName: 'id',
    },
  },
  {
    type: 'SELECT',
    label: '锁定状态',
    value: '',
    upKey: 'locked',
    options: [
      {label: '锁定', id: '1'},
      {label: '未锁定', id: '0'},
    ],
    props: { placeholder: '请选择锁定状态', clearable: true},
    seleProps: { label: 'label', valueName: 'id', },
  },
  {
    type: 'SELECT',
    label: '发送日期',
    value: '',
    upKey: 'sendDate',
    options: [
      {label: '空', id: true},
      {label: '非空', id: false},
    ],
    props: { placeholder: '请选择发送日期', clearable: true},
    seleProps: { label: 'label', valueName: 'id', },
  },
  {
    type: 'SELECT',
    label: '回函日期',
    value: '',
    upKey: 'replyDate',
    options: [
      {label: '空', id: true},
      {label: '非空', id: false},
    ],
    props: { placeholder: '请选择回函日期', clearable: true},
    seleProps: { label: 'label', valueName: 'id', },
  },
  {
    type: 'SELECT',
    label: '销售确认',
    value: '',
    upKey: 'saleConfirm',
    options: [
      {label: '已确认', id: 'true'},
      {label: '未确认', id: 'false'},
    ],
    props: { placeholder: '请选择销售确认', clearable: true},
    seleProps: { label: 'label', valueName: 'id', },
  },
  {
    label: '期次',
    value: '',
    upKey: 'period',
  },
])


const searchHandle = () => {

}
const dynamicColumn = computed(() => {
  if(MI_tableData.value.length === 0) return [];
  return MI_tableData.value[0]?.dynamicData || []
})

// 添加
const addConfig = ref([])
const addFg = ref<boolean>(false)
const addHandle = () => {
  MI_modifyForm({}, addConfig, addFg, async(params: any) => {
    ElMessage.success('成功')
    addFg.value = false
    fetchData(MI_params)
  })
}

// 修改
const modifyFg = ref<boolean>(false)
const modifyHandle = (row: any) => { }

// 删除
const delHandle = (row: any) => {
  if(selectionRows.value.length === 0){
    ElMessage.warning('请至少选择一条数据')
    return
  }
  ElMessageBox.confirm(
    '是否确认删除',
    '提示',
    {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'warning',
    }
  ).then(() => {
    MI_identify.value = true
    return deleteApi({ids: selectionRows.value.map((e: {id: number}) => e.id)})
  }).then(() => {
    MI_identify.value = false
    fetchData(MI_params)
  }).catch(() => {
    MI_identify.value = false
  })
}

// 创建替代测试
const testHandle = () => {
  ElMessageBox.confirm('是否下载创建替代测试', '提示', {type: 'warning'}).then(() => {
    MI_identify.value = false
    // return alternative_testApi(MI_params)
    return exportHandle(alternative_testApi, {
      ...MI_params,
      selectIds: selectionRows.value.map((e: {id: number}) => e.id)
    })
  }).finally(() => {
    MI_identify.value = false
    ElMessage.success('成功')
  })
}

// 上传附件
const uploadHandle = () => {
  ElMessage.warning('请选择一条数据')
}

// 下载询证函
const exportFg = ref<boolean>(false)
const exportConfig = ref([
  {
    type: 'SELECT',
    label: '附件类型',
    value: '',
    upKey: 'type',
    options: confirmationOption(),
    rule: [{ required: true, message: '请选择附件类型', trigger: 'change' }],
    props: { clearable: false, filterable: false, placeholder: '请选择附件类型'},
    seleProps: { label: 'label', valueName: 'id', }
  },
  {
    type: 'SELECT',
    label: '下载类型',
    value: '',
    upKey: 'pdf',
    options: [
      {label: '下载原文件', id: false},
      {label: '下载PDF', id: true},
    ],
    rule: [{ required: true, message: '请选择下载类型', trigger: 'change' }],
    props: { clearable: false, filterable: false, placeholder: '请选择下载类型'},
    seleProps: { label: 'label', valueName: 'id', }
  },
])
const downloadHandle = () => {
  if(selectionRows.value.length === 0){
    ElMessage.warning('请至少选择一条数据')
    return
  }
  MI_modifyForm({}, exportConfig, exportFg, async(params: any) => {
    await exportHandle(downloadApi, {...params, ids: selectionRows.value.map((e: {id: string}) => e.id)})
    // ElMessage.success('下载成功')
    exportFg.value = false
  })
}

// 更新信息
const updataHandle = () => {
  MI_identify.value = true
  updateApi(MI_params).then(() => {
    ElMessage.success('更新成功')
    MI_identify.value = false
    fetchData(MI_params)
  }).catch(() => {
    MI_identify.value = false
  })
}

// 创建询证函
const createFg = ref<boolean>(false)
const createConfig = ref([
  /* {
    type: 'SELECT',
    label: '附件类型',
    value: '',
    upKey: 'type',
    options: confirmationOption(),
    rule: [{ required: true, message: '请选择附件类型', trigger: 'change' }],
    props: { clearable: false, filterable: false, placeholder: '请选择附件类型'},
    seleProps: { label: 'label', valueName: 'id', }
  },
  {
    type: 'SELECT',
    label: '语言',
    value: true,
    upKey: 'en',
    options: [
      {label: '英文', id: true},
      {label: '中文', id: false},
    ],
    rule: [{ required: true, message: '请选择语言', trigger: 'change' }],
    props: { clearable: false, filterable: false, placeholder: '请选择语言'},
    seleProps: { label: 'label', valueName: 'id', }
  }, */
  {
    type: 'SELECT',
    label: '客户名称类型',
    value: '',
    upKey: 'nameType',
    options: [
      {label: '财务认定客户', id: true},
      {label: '客户名称', id: false},
    ],
    props: { clearable: true, placeholder: '请选择客户名称类型'},
    seleProps: { label: 'label', valueName: 'id', }
  },
])
const createLetter = () => {
  if(selectionRows.value.length === 0){
    ElMessage.warning('请至少选择一条数据')
    return
  }
  MI_modifyForm({}, createConfig, createFg, async(params: any) => {
    await createConfirmation_fileApi({
      ids: selectionRows.value.map((row: {id: number}) => row.id),
      ...params
    })
    ElMessage.success('创建成功')
    createFg.value = false
    fetchData(MI_params)
  })




 /*  MI_identify.value = true
  createConfirmation_fileApi({
    ids: selectionRows.value.map((row: {id: number}) => row.id)
  }).then(() => {
    ElMessage.success('创建成功')
    MI_identify.value = false
    fetchData(MI_params)
  }).catch(() => {
    MI_identify.value = false
  })
   */
}

// 单个下载
const singleFg = ref<boolean>(false)
const singleExportConfig = ref([
  {
    type: 'SELECT',
    label: '下载类型',
    value: '',
    upKey: 'pdf',
    options: [
      {label: '下载原文件', id: false},
      {label: '下载PDF', id: true},
    ],
    rule: [{ required: true, message: '请选择下载类型', trigger: 'change' }],
    props: { clearable: false, filterable: false, placeholder: '请选择下载类型'},
    seleProps: { label: 'label', valueName: 'id', }
  },
])
const singleDownload = async (row: any, type: string) => {
  MI_modifyForm({}, singleExportConfig, singleFg, async(params: any) => {
    await exportHandle(downloadApi, {...params, ids: [row.id], type})
    ElMessage.success('下载成功')
    singleFg.value = false
  })
  // downloadApi()
}

// 生成NO
const generateNoFg = ref<boolean>(false)
const generateNoConfig = ref([
  {
    label: '编号',
    value: '',
    upKey: 'num'
  },
  {
    type: 'SELECT',
    label: '询证函主体',
    value: '',
    upKey: 'company',
    options: companyInvice,
    props: {clearable: true, placeholder: '请选择询证函主体'},
    seleProps: {
      label: 'label',
      valueName: 'id',
    },
  },
])
const generateNoHandle = () => {
  MI_modifyForm({}, generateNoConfig, generateNoFg, async(params: any) => {
    await createNoApi(params, {contentType: 'formData'})
    ElMessage.success('创建成功')
    generateNoFg.value = false
    fetchData(MI_params)
  })
}
// 清除NO
const clearFg = ref<boolean>(false)
const clearNoConfig = ref([
  {
    type: 'SELECT',
    label: '询证函主体',
    value: '',
    upKey: 'company',
    options: companyInvice,
    props: {clearable: true, placeholder: '请选择询证函主体'},
    seleProps: {
      label: 'label',
      valueName: 'id',
    },
  },
])
const clearNoHandle = () => {
  MI_modifyForm({}, clearNoConfig, clearFg, async(params: any) => {
    await clearNoApi({
      ...params,
      ids: selectionRows.value.map((row: {id: number}) => row.id),
    })
    ElMessage.success('清除成功')
    clearFg.value = false
    fetchData(MI_params)
  })
}

// 修改询证函
const editFg = ref<boolean>(false)
const editConfig = ref([
  {
    label: '函证序号',
    value: '',
    upKey: 'brokerNo',
  },
  {
    type: "TIME",
    label: "发送时间",
    value: '',
    upKey: 'sendDate',
    props: { 'value-format': 'YYYY-MM-DD', clearable: true, }
  },
  {
    type: 'SELECT',
    label: '合格标志',
    value: '',
    upKey: 'status',
    options: [
      {label: '合格', id: true },
      {label: '不合格', id: false },
    ],
    props: { clearable: true, placeholder: '请选择合格标志'},
    // rule: [{ required: true, message: '请选择合格标志', trigger: 'change' }],
    seleProps: { label: 'label', valueName: 'id', }
  },
])
const editHandle = (data:any) => {
  // if(selectionRows.value.length === 0){
  //   ElMessage.warning('请至少选择一条数据')
  //   return
  // }
  editConfig.value[0].value=data.brokerNo
  editConfig.value[1].value=data.sendDate
  editConfig.value[2].value=data.status

  MI_modifyForm({}, editConfig, editFg, async(params: any) => {
    await updateConfirmationApi({
      // ids: selectionRows.value.map((row: {id: number}) => row.id),
      id: data.id,
      ...params,
      status: params.status === '' ? null : params.status
    })
    ElMessage.success('修改成功')
    editFg.value = false
    fetchData(MI_params)
  })
}
// 锁定解锁
const isShowLock = ref<boolean>(false)
const lockConfig = ref([
  {
    type: 'SELECT',
    label: '操作类型',
    value: '',
    upKey: 'locked',
    options: [
      {label: '锁定', id: true },
      {label: '解锁', id: false },
    ],
    props: { clearable: true, placeholder: '请选择操作类型'},
    rule: [{ required: true, message: '请选择操作类型', trigger: 'change' }],
    seleProps: { label: 'label', valueName: 'id', }
  },
])
const lockHandle = () => {
  if(selectionRows.value.length === 0){
    ElMessage.warning('请至少选择一条数据')
    return
  }
  MI_modifyForm({}, lockConfig, isShowLock, async(params: any) => {
    await lockedApi({
      ids: selectionRows.value.map((row: {id: number}) => row.id),
      ...params,
    })
    ElMessage.success('成功')
    isShowLock.value = false
    fetchData(MI_params)
  })
}

const switchPageHandle = (row: any, index: number) => {
  router.push({ 
    path: '/order-query', 
    query: { ids: row.dynamicData[index].orderIds }
  })
  /* if(column.property === 'orderAmount2021'){
    router.push({ 
      path: '/order-query', 
      query: { ids: row.orderAmount2021Ids }
    })
  }
  if(column.property === 'orderAmount2022'){
    router.push({ 
      path: '/order-query', 
      query: { ids: row.orderAmount2022Ids }
    })
  }
  if(column.property === 'orderAmount2023'){
    router.push({ 
      path: '/order-query', 
      query: { ids: row.orderAmount2023Ids }
    })
  }
  if(column.property === 'payAmount2021'){
    router.push({ 
      path: '/order-query', 
      query: { ids: row.payAmount2021Ids }
    })
  }
  if(column.property === 'payAmount2022'){
    router.push({ 
      path: '/order-query', 
      query: { ids: row.payAmount2022Ids }
    })
  }
  if(column.property === 'payAmount2023'){
    router.push({ 
      path: '/order-query', 
      query: { ids: row.payAmount2023Ids }
    })
  }
  if(column.property === 'notReceivedAmount'){
    router.push({ 
      path: '/order-query', 
      query: { ids: row.notReceivedAmountIds }
    })
  } */
}
const formatAmount = (row: any, index: number) => {
  if(!row.dynamicData) return '-';
  return getNumber(row.dynamicData[index].amount)

}
// ----------
// 境内外格式化
const formatDomestic = (row: {domestic: boolean | null}) => {
  if(row.domestic === true){
    return '境内'
  }
  if(row.domestic === false){
    return '境外'
  }
  return '未知'
}

const tableRowClassName = ({ row, rowIndex }: any) => {
  if (row.invoiceCompany !== row.confirmationCompany ) {
    return 'remarkRow'
  }
  return ''
}

return (_ctx: any,_cache: any) => {
  const _component_FlexibleForm = _resolveComponent("FlexibleForm")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_TheUpBtn = _resolveComponent("TheUpBtn")!
  const _component_eptBtn = _resolveComponent("eptBtn")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_permission = _resolveDirective("permission")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_collapse, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, { title: "询证函-搜索" }, {
          default: _withCtx(() => [
            _createVNode(_component_FlexibleForm, _mergeProps({ ref: "searchForm" }, {
          title: true,
          searchConfig: searchConfig.value,
        }, { onSearchFn: _unref(fetchData) }), null, 16, ["onSearchFn"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (generateNoHandle()))
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (clearNoHandle()))
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (createLetter())),
        type: "primary"
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }),
      (_unref(selectionRows).length === 1)
        ? _withDirectives((_openBlock(), _createBlock(_component_TheUpBtn, {
            key: 0,
            upText: '上传询证函',
            upFetch: _unref(uploadApi),
            upParams: {id: _unref(selectionRows)[0].id},
            upConfig: [exportConfig.value[0]],
            onUpSuccess: _cache[3] || (_cache[3] = ($event: any) => (_unref(fetchData)(_unref(MI_params)))),
            showBtn: true
          }, null, 8, ["upFetch", "upParams", "upConfig"])), [
            [_directive_permission, 'Create']
          ])
        : _createCommentVNode("", true),
      (_unref(selectionRows).length !== 1)
        ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            onClick: _cache[4] || (_cache[4] = ($event: any) => (uploadHandle()))
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          })), [
            [_directive_permission, 'Create']
          ])
        : _createCommentVNode("", true),
      _withDirectives((_openBlock(), _createBlock(_component_el_button, {
        type: "",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (downloadHandle()))
      }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      })), [
        [_directive_permission, 'Export']
      ]),
      _withDirectives(_createVNode(_component_eptBtn, {
        exportFn: _unref(exportApi),
        exportText: '导出询证函',
        exportParam: _unref(MI_params)
      }, null, 8, ["exportFn", "exportParam"]), [
        [_directive_permission, 'Export']
      ]),
      _createVNode(_component_el_button, {
        onClick: _cache[6] || (_cache[6] = ($event: any) => (updataHandle()))
      }, {
        default: _withCtx(() => [
          _hoisted_7
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        onClick: _cache[7] || (_cache[7] = ($event: any) => (lockHandle()))
      }, {
        default: _withCtx(() => [
          _hoisted_8
        ]),
        _: 1
      }),
      _withDirectives((_openBlock(), _createBlock(_component_el_button, {
        type: "danger",
        onClick: delHandle
      }, {
        default: _withCtx(() => [
          _hoisted_9
        ]),
        _: 1
      })), [
        [_directive_permission, 'Delete']
      ]),
      _createVNode(_component_el_button, {
        onClick: _cache[8] || (_cache[8] = ($event: any) => (testHandle()))
      }, {
        default: _withCtx(() => [
          _hoisted_10
        ]),
        _: 1
      })
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      ref: "tb",
      border: "",
      data: _unref(MI_tableData),
      "row-class-name": tableRowClassName,
      onSelectionChange: _cache[9] || (_cache[9] = (rows) => _isRef(selectionRows) //@ts-ignore
 ? selectionRows.value = rows : selectionRows = rows),
      "max-height": _unref(MI_height) - 80 + 'px'
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          fixed: "",
          type: "selection",
          width: "55"
        }),
        _createVNode(_component_el_table_column, {
          fixed: "",
          width: "130",
          label: "客户ID",
          prop: "customerId",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          width: "130",
          label: "客户名称",
          prop: "customerName",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          width: "110",
          label: "公司",
          prop: "invoiceCompany",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "币种",
          prop: "currency",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "期次",
          prop: "period",
          align: "right"
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dynamicColumn), (col, index) => {
          return (_openBlock(), _createBlock(_component_el_table_column, {
            label: col.label,
            width: "130",
            align: "right"
          }, {
            default: _withCtx(({ row }) => [
              _createElementVNode("span", {
                onDblclick: ($event: any) => (switchPageHandle(row, index))
              }, _toDisplayString(formatAmount(row, index)), 41, _hoisted_11)
            ]),
            _: 2
          }, 1032, ["label"]))
        }), 256)),
        _createVNode(_component_el_table_column, {
          width: "110",
          label: "询证函主体",
          prop: "confirmationCompany",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          width: "110",
          label: "财务认定客户",
          prop: "financialName",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          width: "110",
          label: "对方联系人",
          prop: "contacts",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          width: "130",
          label: "邮箱地址",
          prop: "mail",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          width: "100",
          label: "快递地址",
          prop: "address",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          width: "100",
          label: "客户备注",
          prop: "remarks",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          width: "100",
          label: "函证序号",
          prop: "brokerNo",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          width: "100",
          label: "境内外",
          prop: "domestic",
          "show-overflow-tooltip": "",
          formatter: formatDomestic
        }),
        _createVNode(_component_el_table_column, {
          width: "100",
          label: "销售",
          prop: "sale",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          width: "100",
          label: "团队",
          prop: "orgName",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          width: "100",
          label: "抄送销售邮箱地址",
          prop: "saleMail",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          width: "100",
          label: "发送日期",
          prop: "sendDate",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          width: "100",
          label: "函证附件",
          prop: "brokerFileKey",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_link, {
              type: "primary",
              disabled: !row.brokerFileKey,
              onClick: ($event: any) => (singleDownload(row, 'broker'))
            }, {
              default: _withCtx(() => [
                _hoisted_12
              ]),
              _: 2
            }, 1032, ["disabled", "onClick"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          width: "120",
          label: "回函附件",
          prop: "brokerReplyFileKey",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_link, {
              type: "primary",
              disabled: !row.brokerReplyFileKey,
              onClick: ($event: any) => (singleDownload(row, 'broker_reply'))
            }, {
              default: _withCtx(() => [
                _hoisted_13
              ]),
              _: 2
            }, 1032, ["disabled", "onClick"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          width: "100",
          label: "回函备注",
          prop: "replyRemarks",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          width: "120",
          label: "回函日期",
          prop: "brokerReplyDate",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          width: "100",
          label: "合格标志",
          prop: "pass",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          width: "100",
          label: "销售确认",
          prop: "account.saleConfirm",
          formatter: (row) => row.saleConfirm === true ? '已确认' : '未确认'
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          width: "100",
          label: "锁定状态",
          prop: "locked",
          "show-overflow-tooltip": "",
          formatter: (row) => row.locked === true ? '已锁定': '未锁定'
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          width: "110",
          label: "起始日期",
          prop: "startDate",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          width: "110",
          label: "结束日期",
          prop: "endDate",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          width: "110",
          label: "操作",
          prop: "ops",
          fixed: "right"
        }, {
          default: _withCtx(({row}) => [
            _createVNode(_component_el_space, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_link, {
                  underline: false,
                  type: "primary",
                  onClick: ($event: any) => (editHandle(row))
                }, {
                  default: _withCtx(() => [
                    _hoisted_14
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "max-height"])), [
      [_directive_loading, _unref(MI_identify)]
    ]),
    _createVNode(_component_el_pagination, {
      background: "",
      small: "",
      total: _unref(MI_total),
      currentPage: _unref(page),
      "onUpdate:currentPage": _cache[10] || (_cache[10] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
      "page-size": _unref(size),
      "onUpdate:page-size": _cache[11] || (_cache[11] = ($event: any) => (_isRef(size) ? (size).value = $event : null)),
      class: "mt-10",
      "page-sizes": [10, 30, 50, 200, 500, 1000],
      layout: "sizes, prev, pager, next, total, jumper",
      onCurrentChange: _unref(MI_pageChange),
      onSizeChange: _unref(MI_sizeChange)
    }, null, 8, ["total", "currentPage", "page-size", "onCurrentChange", "onSizeChange"]),
    _createVNode(_component_el_dialog, {
      modelValue: exportFg.value,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((exportFg).value = $event)),
      title: "下载附件"
    }, {
      default: _withCtx(() => [
        (exportFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
          searchConfig: exportConfig.value,
          submitText: '确定'
        })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: singleFg.value,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((singleFg).value = $event)),
      title: "下载单个附件"
    }, {
      default: _withCtx(() => [
        (singleFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
          searchConfig: singleExportConfig.value,
          submitText: '确定'
        })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: generateNoFg.value,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((generateNoFg).value = $event)),
      title: "生成No"
    }, {
      default: _withCtx(() => [
        (generateNoFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
          searchConfig: generateNoConfig.value,
          submitText: '确定'
        })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: clearFg.value,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((clearFg).value = $event)),
      title: "清除NO"
    }, {
      default: _withCtx(() => [
        (clearFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
          searchConfig: clearNoConfig.value,
          submitText: '确定'
        })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: createFg.value,
      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((createFg).value = $event)),
      title: "创建询证函"
    }, {
      default: _withCtx(() => [
        (createFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
          searchConfig: createConfig.value,
          submitText: '确定'
        })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: editFg.value,
      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((editFg).value = $event)),
      title: "修改询证函"
    }, {
      default: _withCtx(() => [
        (editFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
          searchConfig: editConfig.value,
          submitText: '确定'
        })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: isShowLock.value,
      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((isShowLock).value = $event)),
      title: "锁定/解锁"
    }, {
      default: _withCtx(() => [
        (isShowLock.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
          searchConfig: lockConfig.value,
          submitText: '确定'
        })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})